/* =============================================================
   TRESTLETHORN — Product Tabs JS
   File: assets/tt-product-tabs.js

   Add to layout/theme.liquid before </body>:
     <script src="{{ 'tt-product-tabs.js' | asset_url }}" defer></script>

   OR paste the initProductTabs() function body into
   assets/trestlethorn-theme.js (already linked in Package 1).
   ============================================================= */

(function () {
  'use strict';

  function initProductTabs() {
    document.querySelectorAll('.tt-tabs').forEach(tabGroup => {
      const buttons = tabGroup.querySelectorAll('.tt-tabs__btn');
      const panels  = tabGroup.querySelectorAll('.tt-tabs__panel');

      buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          // Deactivate all
          buttons.forEach(b => {
            b.classList.remove('tt-tabs__btn--active');
            b.setAttribute('aria-selected', 'false');
            b.setAttribute('tabindex', '-1');
          });
          panels.forEach(p => {
            p.classList.remove('tt-tabs__panel--active');
            p.hidden = true;
          });

          // Activate clicked
          btn.classList.add('tt-tabs__btn--active');
          btn.setAttribute('aria-selected', 'true');
          btn.removeAttribute('tabindex');
          panels[i].classList.add('tt-tabs__panel--active');
          panels[i].hidden = false;
        });

        // Keyboard: left/right arrow navigation
        btn.addEventListener('keydown', e => {
          let target = null;
          if (e.key === 'ArrowRight') target = buttons[i + 1] || buttons[0];
          if (e.key === 'ArrowLeft')  target = buttons[i - 1] || buttons[buttons.length - 1];
          if (target) { target.focus(); target.click(); }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  document.addEventListener('shopify:section:load', initProductTabs);

})();
